import FormattedNumber from 'I18n/components/FormattedNumber';
import { jsx as _jsx } from "react/jsx-runtime";
export function FormatClamped({
  value,
  min,
  max
}) {
  return /*#__PURE__*/_jsx(FormattedNumber, {
    value: Math.min(Math.max(value, min), max)
  });
}